import { useEffect, useState } from "react";
import { api, errorText } from "@/lib/api";
import { PageTitle } from "./AdminOverview";
import { FormError, FormSuccess } from "@/components/brand/Field";

const STATUS_COLOR = { sent: "var(--blue)", failed: "var(--red)", skipped: "var(--muted-text)", logged: "var(--amber)" };
const KIND_LABEL = {
  verify: "Verify email", verification: "Verify email", reset: "Password reset", password_reset: "Password reset",
  email_change: "Email change", email_change_notice: "Email change notice", renewal_alert: "Renewal alert",
  weekly_digest: "Weekly digest", digest: "Weekly digest", account_deletion: "Deletion notice",
  account_deleted: "Deletion receipt", data_export: "Data export", welcome: "Welcome", resend: "Resend",
};
const kindText = (k) => KIND_LABEL[k] || (k || "").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
const reasonText = (r) => r.status === "failed" ? (r.error || "Send failed") : r.status === "skipped" ? (r.note || "Test address") : r.status === "sent" ? "Delivered to provider" : "Logged only";

export default function AdminEmails() {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(null);
  const [err, setErr] = useState(""); const [msg, setMsg] = useState("");
  const load = () => api.get("/admin/outbound-emails").then((r) => setRows(r.data)).catch((e) => setErr(errorText(e)));
  useEffect(() => { load(); }, []);
  const view = (id) => api.get(`/admin/outbound-emails/${id}`).then((r) => setOpen(r.data)).catch((e) => setErr(errorText(e)));
  const resend = async (id) => { setErr(""); setMsg(""); try { const r = await api.post(`/admin/outbound-emails/${id}/resend`); setMsg(`Resent · ${r.data.status}.`); await load(); } catch (e) { setErr(errorText(e)); } };
  return (
    <>
      <PageTitle eyebrow="Delivery" title="Outbound email" />
      <FormSuccess message={msg} testId="emails-success" /><FormError message={err} testId="emails-error" />
      <p className="text-xs mb-3" style={{ color: "var(--muted-text)" }}>Every transactional email we attempt, with delivery status. Test addresses are skipped. Viewing a body is audit-logged.</p>
      <div className="grid lg:grid-cols-2 gap-6">
        <div className="ts-card overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm" style={{ minWidth: 640, tableLayout: "fixed" }}>
              <colgroup><col style={{ width: 118 }} /><col style={{ width: 180 }} /><col style={{ width: 120 }} /><col style={{ width: 86 }} /><col /><col style={{ width: 70 }} /></colgroup>
              <thead><tr className="text-left eyebrow" style={{ background: "var(--paper)" }}><th className="p-3">When</th><th>To</th><th>Kind</th><th>Status</th><th>Reason</th><th></th></tr></thead>
              <tbody data-testid="emails-table">
                {rows.map((r) => (
                  <tr key={r.id} className="border-t align-top hover:bg-[var(--paper)]" style={{ borderColor: "var(--line-soft)" }} data-testid={`email-row-${r.id}`}>
                    <td className="p-3 num text-xs whitespace-nowrap cursor-pointer" onClick={() => view(r.id)}>{r.created_at.slice(0, 16).replace("T", " ")}</td>
                    <td className="text-xs truncate cursor-pointer" title={r.to} onClick={() => view(r.id)}>{r.to}</td>
                    <td className="text-xs truncate cursor-pointer" title={kindText(r.kind)} onClick={() => view(r.id)}>{kindText(r.kind)}</td>
                    <td className="text-xs font-semibold" style={{ color: STATUS_COLOR[r.status] || "var(--ink)" }}>{r.status === "skipped" ? "skipped" : r.status}</td>
                    <td className="text-xs truncate" style={{ color: "var(--muted-text)" }} title={reasonText(r)}>{reasonText(r)}</td>
                    <td className="pr-3 text-right">{r.status === "failed" && <button className="ts-link text-xs whitespace-nowrap" onClick={() => resend(r.id)} data-testid={`email-resend-${r.id}`}>Resend</button>}</td>
                  </tr>
                ))}
                {!rows.length && <tr><td className="p-4 text-sm" colSpan={6} style={{ color: "var(--muted-text)" }}>No emails yet.</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
        {open && (
          <div className="ts-card p-4" data-testid="email-preview">
            <p className="eyebrow mb-1">Subject</p><p className="text-sm font-medium mb-1">{open.subject}</p>
            <p className="text-xs mb-3" style={{ color: "var(--muted-text)" }}>{kindText(open.kind)} · to {open.to} · {open.status}</p>
            {open.error && <p className="ts-error mb-2 break-words">{open.error}</p>}
            {open.status === "failed" && <button className="ts-btn ts-btn-ghost h-8 text-xs mb-3" onClick={() => resend(open.id)} data-testid="email-preview-resend">Resend this email</button>}
            <iframe title="Email preview" srcDoc={open.html} sandbox="" className="w-full h-[460px] border rounded" style={{ borderColor: "var(--line)" }} />
          </div>
        )}
      </div>
    </>
  );
}
